export default {
  visualization: () => import('./views/visualization/visualization.vue'),
  'data-query': () => import('./views/data-query/data-query.vue'),
  'illegal-spots': () => import('./views/illegal-spots/index.vue'),
  'comparison-analysis': () => import('./views/comparison-analysis/comparison-analysis.vue'),
  'chart-production': () => import('./views/chart-production/chart-production.vue'),
  feedback: () => import('./views/acm/feedback/feedback.vue'),
  'breed-planning': () => import('./views/acm/breed-planinng/breed-planning.vue'),
  'breed-statusquo': () => import('./views/acm/breed-statusquo/breed-statusquo.vue'),
  'breed-illegal': () => import('./views/acm/breed-illegal/breed-illegal.vue'),
  'present-forbiden': () => import('./views/acm/present-forbiden/present-forbiden.vue'),
  'disposal-management': () => import('./views/acm/disposal-management'),
  'disposition-audits': () => import('./views/acm/disposition-audits'),
  'task-dispose': () => import('./views/acm/task-dispose/task-dispose.vue'),
  'illegal-rule': () => import('./views/acm/illegal-rule/index.vue'),
  // 养殖证管理
  'certificate-manage': () => import('./views/certificate-manage/index.vue'),
  // 养殖证导入
  'certificate-import': () => import('./views/acm/farming-certificate/certificate-import/index.vue'),
  // 养殖证管理
  'certificate-disposal-management': () => import('./views/acm/farming-certificate/disposal-management'),
  'certificate-disposition-audits': () => import('./views/acm/farming-certificate/disposition-audits'),
  'certificate-task-dispose': () => import('./views/acm/farming-certificate/task-dispose/task-dispose.vue'),
  'certificate-illegal-rule': () => import('./views/acm/farming-certificate/illegal-rule/index.vue'),
  'certificate-statistics': () => import('./views/acm/farming-certificate/certificate-statistics/index.vue'),
  'related-words': () => import('./views/acm/related-words/index.vue')
}
